<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <breadcrumb></breadcrumb>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <span>{{ username }}</span>
          <!--          <img class="user-avatar" :src="avatar">-->
                    <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="dialogVisible=true" style="display:block;">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出</span>
          </el-dropdown-item>

        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>

    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="30%">
      <div style="display: flex;flex-direction: column">
        <el-input v-model="oldpwd" placeholder="请输入旧密码" style="width: 300px"></el-input>
        <el-input v-model="newpwd" placeholder="请输入新密码" maxlength="12" style="width: 300px;margin-top: 20px"></el-input>
        <el-input v-model="aginpwd" placeholder="请重复新密码" maxlength="12"
                  style="width: 300px;margin-top: 20px"></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="handleSubmit">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import {getCookie} from '@/utils/support';
import {updatepwd} from '@/api/updatepwd';

export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  data() {
    return {
      dialogVisible: false,
      oldpwd: '',
      newpwd: '',
      username: getCookie("username"),
      aginpwd: ''
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    //修改密码
    handleSubmit() {
      if (!this.oldpwd) {
        this.$message({
          type: 'error',
          message: '请输入旧密码'
        });
      } else if (!this.newpwd) {
        this.$message({
          type: 'error',
          message: '请输入新密码'
        });
      } else if (this.newpwd.length < 6) {
        this.$message({
          type: 'error',
          message: '新密码必须大于6位'
        });
      } else if (this.newpwd !== this.aginpwd) {
        this.$message({
          type: 'error',
          message: '两次密码输入不一致'
        });
      } else {
        //调用修改密码接口
        updatepwd({
          username: getCookie("username"),
          oldPassword: this.oldpwd,
          newPassword: this.newpwd
        }).then(respons => {
          this.dialogVisible = false
          this.$message({
            type: 'success',
            message: '请重新登录'
          });
          this.$store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
    }

  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 50px;

    .avatar-wrapper {
      cursor: pointer;
      margin-top: 0px;
      position: relative;

      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 20px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue